import { Button, Input, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { BsFillPlayFill, BsPauseFill } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import { FiEdit, FiEye } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { DataTable } from "@/components";
import { userRole } from "@/constant";
import { flare } from "@flareapp/js";

const BusinessList = () => {
  const userDetails = useSelector((state) => state.user.userDetails);
  const [isLoading, setIsLoading] = useState(false);
  const [businesses, setBusinesses] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [total, setTotal] = useState();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const getBusiness = async () => {
    setIsLoading(true);
    try {
      const data = await api.get(endpoint.business + "with-site", { params: { searchText, limit, page } });
      setBusinesses(data?.data || []);
      setTotal(data?.count || 0);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business list", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    document.title = `${appConfig.name} - All Businesses`;
    getBusiness();
  }, [searchText, limit, page]);

  const columns = [
    {
      title: "No",
      render: (_, __, index) => index + 1 + limit * (page - 1),
      width: "60px",
    },
    {
      title: "Business Name",
      render: (_, row) => (
        <>
          {row.name} ({row.id})
        </>
      ),
      // grow: 2.5,
    },
    // {
    //   title: "Assinged Subscription",
    //   render: (_, row) => (
    //     <>
    //       {row.name} ({row.id})
    //     </>
    //   ),
    //   // grow: 2.5,
    // },
    {
      title: "Site",
      render: (_, row) => row?.siteLocation?.length || 0,
      align: "center",
      // center: true,
      // width: "60px",
    },
    {
      title: "Devices",
      render: (_, row) => row?.devices?.length || 0,
      align: "center",
      // width: "90px",
    },
    {
      title: "Business Admin",
      render: (_, row) => row?.businessAdmin?.length || 0,
      align: "center",

      // width: "130px",
    },
    {
      title: "Site Admin",
      render: (_, row) => row?.admin?.length || 0,
      align: "center",
      // width: "110px",
    },
    {
      title: "Installer",
      render: (_, row) => row?.installer?.length || 0,
      // render: (_, row) => (row?.siteLocation?.length > 0 ? row?.siteLocation[0]?.installer?.length : 0),
      // width: "90px",
      align: "center",
    },
    {
      title: "Users",
      render: (_, row) => row?.users?.length || 0,
      align: "center",
      // width: "80px",
    },
    {
      title: "Public",
      render: (_, row) => row?.public?.length || 0,
      align: "center",
      // width: "80px",
    },
    {
      title: "Status",
      render: (_, row) => (
        <div>
          {row.isActive ? (
            <span className="badge text-bg-success">Active</span>
          ) : (
            <span className="badge text-bg-danger">Deactivated</span>
          )}
        </div>
      ),
      align: "center",
      // minWidth: "100px",
    },
    {
      title: "Action",
      render: (_, row) => (
        <div>
          {(() => {
            switch (userDetails.role) {
              case "superAdmin":
                return (
                  <div className="actions">
                    <Link to={`/business/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                    <Link to={`/business/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit title="Edit" />
                    </Link>
                    {row.isActive ? (
                      <button className="btn btn-warning  me-1" onClick={() => deleteBusiness(row._id, row.isActive)}>
                        <BsPauseFill title="Inactive" />
                      </button>
                    ) : (
                      <button className="btn btn-success  me-1" onClick={() => deleteBusiness(row._id, row.isActive)}>
                        <BsFillPlayFill title="Active" />
                      </button>
                    )}
                  </div>
                );

              case userRole.businessAdmin:
                return (
                  <div className="actions">
                    <Link to={`/business/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                    <Link to={`/business/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit title="Edit" />
                    </Link>
                  </div>
                );
              case "admin":
                return (
                  <div className="actions">
                    <Link to={`/business/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                    {/* <Link to={`/business/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit title="Edit" />
                    </Link> */}
                  </div>
                );
              case "installer":
                return (
                  <div className="actions">
                    <Link to={`/business/details/` + row._id} className="btn btn-success me-1">
                      <FiEye title="View" />
                    </Link>
                  </div>
                );
              case "user":
                return (
                  <div className="actions">
                    <Link to={`/business/details/` + row._id} className="btn btn-success me-1">
                      <FiEye title="View" />
                    </Link>
                  </div>
                );
              case "public":
                return (
                  <div className="actions">
                    <Link to={`/business/details/` + row._id} className="btn btn-success me-1">
                      <FiEye title="View" />
                    </Link>
                  </div>
                );
              default:
                return;
            }
          })()}
        </div>
      ),
      // grow: 2,
      align: "center",
      width: "240px",
    },
  ];
  const deleteBusiness = async (businessId, isActive) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to ${isActive ? "deactivate" : "activate"} this business?`,
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`/business/` + businessId, {
            withCredentials: true,
          })
          .then((res) => {
            getBusiness();
            Swal.fire({
              title: "Done!",
              text: res?.data?.message || `Business successfully ${isActive ? "deactivated" : "activated"}!`,
              icon: "success",
              timer: 2000,
              button: false,
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "",
              text: error?.response?.data?.message || "Error happened",
              icon: "error",
              timer: 2000,
              button: false,
            });
          });
      }
    });
  };
  return (
    <div className="card p-3 m-md-3">
      <div className="d-flex flex-column flex-md-row g-3 align-items-md-center mb-3 justify-content-between">
        <div>
          <label className="az-content-label">Manage Businesses</label>
          <span className="d-block py-2">{userDetails?.role === userRole.superAdmin ? "All" : "My"} Businesses</span>
        </div>
        <div className="ms-md-auto">
          {userDetails?.role === userRole.superAdmin ? (
            <Link to="/business/create">
              <Button icon={<FaPlus />} type="primary">
                {" "}
                Create New Business{" "}
              </Button>
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
      <hr className="mt-0" />
      <div className="row mb-2">
        <div className="col-md-10"></div>
        <div className="col-md-2">
          <Input
            type="search"
            size="large"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
            placeholder="Search"
            // className="me-2"
            aria-label="Search"
          />
        </div>
      </div>
      <Spin spinning={isLoading}>
        <DataTable
          dataSource={businesses}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={{
            defaultPageSize: limit,
            current: page,
            total,
            showSizeChanger: true,
            onShowSizeChange: (_, pageSize) => {
              setLimit(pageSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            pageSizeOptions: [10, 20, 50],
            responsive: true,
          }}
          onChange={(pagination) => {
            setPage(pagination.current);
          }}
        />
      </Spin>
    </div>
  );
};

export default BusinessList;
